import { render, staticRenderFns } from "./ReviewAndConsent.vue?vue&type=template&id=cfdf9afe&scoped=true"
import script from "./ReviewAndConsent.vue?vue&type=script&lang=js"
export * from "./ReviewAndConsent.vue?vue&type=script&lang=js"
import style0 from "./ReviewAndConsent.vue?vue&type=style&index=0&id=cfdf9afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdf9afe",
  null
  
)

export default component.exports